import React from 'react';
import styled from 'styled-components';
import { colours } from 'styling/colours';
import infoBg from '../icons/infoBg.svg';
import { EstimateType } from 'types/Estimate';

const StyledParagraph = styled.p`
  font-size: 15px;
  line-height: 22px;
  letter-spacing: 0px;
  color: ${colours.primaryText};
  background: url(${infoBg}) no-repeat;
  background-size: 21px 20px;
  background-position-x: left;
  background-position-y: top;
  padding-left: 30px;
  margin: 30px 0 40px;
`;

const ArchiveAssetModalContent = ({
  selectedAssetDetails,
}: {
  selectedAssetDetails: EstimateType;
}) => {
  return (
    <>
      <p>
        Are you sure you want to archive{' '}
        <strong id="archiveAssetWarningMessage">
          {selectedAssetDetails.asset_name} - {selectedAssetDetails.asset_type.name}
        </strong>
        ?
      </p>
      <StyledParagraph>
        Please note, archived assets will not be displayed in the asset list and you cannot find
        them by searching.
      </StyledParagraph>
    </>
  );
};
export default ArchiveAssetModalContent;
